<div class="govuk-width-container">
    <main class="govuk-main-wrapper">
        <div class="govuk-grid-row grey-box center">
            <h1>
                404 site not found
            </h1>
        </div>
    </main>
</div>